import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { themeModule } from './theme';
import { productModule } from './product';
import { authModule } from './product/auth';

export default createApp({
  features: [catalogPlugin, navModule, themeModule, productModule, authModule],
});
